import { FC } from 'react';
import { Spin } from 'antd';

import Modal from '../../../components/Modal/Modal';
import css from '../CourseEnrollment.module.css';

export interface PreviousListener {
  listenerUid: string;
  fioRu: string;
  fioBy: string | null;
  address: string | null;
  passportNumber: string | null;
  passportIssueDate: string | null;
  passportIssuedBy: string | null;
  email: string | null;
}

interface Props {
  open: boolean;
  loading: boolean;
  listeners: PreviousListener[];
  onSelect: (l: PreviousListener) => void;
  onClose: () => void;
}

const PreviousListenersModal: FC<Props> = ({ open, loading, listeners, onSelect, onClose }) => (
  <Modal display={open} onClose={onClose} title='Выберите слушателя'>
    {loading ? (
      <div className={css.PrevListenersSpinner}>
        <Spin />
      </div>
    ) : listeners.length === 0 ? (
      <p>Ранее введённых слушателей нет.</p>
    ) : (
      <div className={css.PrevListenersList}>
        {listeners.map((l) => (
          <button
            key={l.listenerUid}
            type='button'
            className={css.PrevListenerRow}
            onClick={() => onSelect(l)}
          >
            <span className={css.PrevListenerName}>{l.fioRu}</span>
            {l.passportNumber && (
              <span className={css.PrevListenerPassport}>{l.passportNumber}</span>
            )}
          </button>
        ))}
      </div>
    )}
  </Modal>
);

export default PreviousListenersModal;
